import { push } from 'connected-react-router';
import { getTeamUrl } from 'Common';

export default (order) => async (dispatch) => {

  dispatch(push(getTeamUrl(`orders/${order.id}/view`)))
  
}